// core/data/follows.ts — typed seed for the follows list.
//
// Ported from legacy src/scripts/data/follows.js.
// These are the accounts that the current (guest) user follows by default in the
// seed state.  The followStore hydrates the follow-set from these at module init.

import type { FollowEntry } from '@/core/models/follow';

export const seedFollows: FollowEntry[] = [
  { name: 'FreeThinker',  handle: '@FreeThinker',  verified: true, av: 'av-4' },
  { name: 'LibertyVoice', handle: '@LibertyVoice', verified: true, av: 'av-5' },
  { name: 'OpenMind',     handle: '@OpenMindX',    verified: true, av: 'av-2' },
];
